<template>
	<div class="layoutgrid">
		<el-container >
			  <el-main>
				  <el-row>
				  	<el-col :span="17" v-if="isbuttons" style="padding-left:10rpx;">
				  		<handlerbutton :l_id="l_id" @buttoncb="buttoncb" @sethandelshow="sethandelshow"></handlerbutton>
				  	</el-col>
				  	<el-col :span="17" v-if="!isbuttons">
				  		<span style="color:transparent;">1</span>
				  	</el-col>
				  	<el-col :span="1" class="rightcol" v-if="showreset">
						<resetfilter :ref="'resetfilter_'+l_id" :l_id="l_id" @resetfiltercb="resetfiltercb" @sethandelshow="sethandelshow"></resetfilter>
					</el-col>
					<el-col :span="1" v-if="!showreset">
						<span style="color:transparent;">1</span>
					</el-col>
				  	<el-col :span="4" v-if="showsearchinput">
				  		<searchinput :ref="'searchinput_'+l_id" :l_id="l_id" @searchinputcb="searchinputcb" @sethandelshow="sethandelshow"></searchinput>
				  	</el-col>
					<el-col :span="4" v-if="!showsearchinput">
						<span style="color:transparent;">1</span>
					</el-col>
				  	<el-col :span="2" style="padding-left:10px;" v-if="showmorefilter">
				  		<morefilter :ref="'morefilter_'+l_id" :l_id="l_id" @morefiltercb="morefiltercb" @sethandelshow="sethandelshow"></morefilter>
				  	</el-col>
					<el-col :span="2" v-if="!showmorefilter">
						<span style="color:transparent;">1</span>
					</el-col>
				  </el-row>
				  <el-row style="margin-top:10px">
					  <tableexpand 
					  	v-if="isgridexpand"
					  	style="width:100%;"
					  	v-loading="loading"
					  	:ref="'gridexpands_'+l_id" 
					  	:tableData="gridlist"
					  	:columns="columns"
					  	@gridhandle="gridhandle"
					  	:gridheight="gridheight"
					  	@gridsort="gridsort"
					  	@checkboxchange="checkboxchange"
					  	@gridscroll="gridscroll"
					  	@rowdblclick="rowdblclick"
					  	:istop="istop"
					  	:soncolumns="soncolumns"
					  	:isexpand="isexpand"
					  	@getExpandsRow="getExpandsRow"
						@cellclick="cellclick"
					  	:rowkey="item.l_tablename"
					  ></tableexpand>
					  
					<tableui style="width:100%;" v-if="!isgridexpand" v-loading="loading"
					  editcell="0" 
					  :ref="'grid_'+l_id" 
					  :tableData="gridlist" 
					  :columns="columns" 
					  @gridsort="gridsort"
					  @gridhandle="gridhandle" 
					  :gridheight="gridheight"
					  @gridscroll="gridscroll"
					  @rowdblclick="rowdblclick"
					  @checkboxchange="checkboxchange"
					  @cellclick="cellclick"
					  :isCopyRange="iscopytable"
					  ></tableui>
				  </el-row>
			  </el-main>
			  <el-footer height="30px" v-if="ispagecount" style="margin-top:-20px">
				  <span>共{{ count }}条数据</span>
			  </el-footer>
		</el-container>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import handlerbutton from '@/components/handlerbutton/handlerbtn.vue';
import morefilter from '@/components/filter/morefilter.vue';
import tableui from '@/components/table/tablegrid.vue';
import tableexpand  from '@/components/table/tablegrid_expand.vue';
import searchinput from '@/components/filter/searchinput.vue';
import resetfilter from '@/components/filter/resetfilter.vue';
export default {
	name:'buttonandgrid',
	components: {
		handlerbutton,
		tableui,
		morefilter,
		searchinput,
		resetfilter,
		tableexpand
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {};
			}
		},
		item: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		isgridexpand:{
			type: Boolean,
			default:false
		}
	},
	data() {
		return {
			//item:{}
			filtermore:false,
			gridlist:[],
			columns:[],
			spaceheight:0,
			loading:false,
			isbuttons:true,
			showreset:true,
			showsearchinput:true,
			showmorefilter:true,
			searchkey:'',
			count:0,
			gridheight:'',
			l_id:'',
			pageindex:0,
			sort:'',
			pagecount:1,
			soncolumns:[],
			checkedrow:[],
			istop:false,
			isexpand:true,
			grid_lang:{},
			gridfilter:'',
			gridlistparam:'',
			ispagecount:true ,//是否为当页汇总
			selectedall:false,
			pagesize:200,
			divclass:'layoutgrid',
			iscopytable:true
		}
	},
	created() {
		debugger
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined&&this.item.l_tabevent!='0')
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
		if(this.item.l_tabcount!=undefined){
			//debugger
			if(this.item.l_tabcount.toString().toLowerCase()=="false")
			//if(this.item.l_tabcount.toString())
				this.ispagecount=true;
			else 
				this.ispagecount=false;
		}
		if(this.item.iswin!=undefined){
			if(this.item.iswin){
				this.gridheight=(window.innerHeight *52) / 100 + 'px';
			}
		}
		// //debugger
		if(this.gridheight=='')
			this.gridheight=(window.innerHeight * 70) / 100 + 'px';
			
	},
	mounted() {
		//console.log('layoutgrid加载--'+this.item.l_id+'  '+this.$tool.formatdate());
		import('../../static/' + this.$theme + '/style/layoutgrid.scss');			
		this.init();
		var that=this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});	
	},
	methods:{
		init(){
			this.loading=true;
			//this.$tool.loading(this.$lang.label.public.loading);
			var that=this;
			//debugger
			this.$public.GetLanguageByMode('gridcol',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.grid_lang=that.$lang.label.gridcol;
					that.getColumns();
				}
				else{
					this.loading=false;
					//this.$tool.loadingclose();
				}
			});
		},
		GetSearchObj(){
			var search={};
			//debugger
			if(this.showsearchinput){
				if(this.$refs['searchinput_'+this.item.l_id]!=undefined)
				{
					search.searchbox=this.$refs['searchinput_'+this.item.l_id].searchkey;
					search.searchcol=this.$refs['searchinput_'+this.item.l_id].searchcol;
				}
			}
			if(this.showmorefilter){
				if(this.$refs['morefilter_'+this.item.l_id]!=undefined){
					search.fname=this.$refs['morefilter_'+this.item.l_id].commfname;
					var filterlist=this.$refs['morefilter_'+this.item.l_id].filterlist;
					if (search.fname != '') {
						var searchtype = '';
						filterlist.forEach(e => {
							if (e.fname == search.fname) {
								if (e.handlertype == 'filter') {
									searchtype = e.searchtype;
									search.fixfilter=e.filter;
									return false;
								} else if (e.handlertype == 'sort') {
									searchtype = '';
									search.fixfilter = '';
									search.fixsort = e.filter;
									return false;
								}
							}
						});
						search.searchtype = searchtype;
					}else
						delete search.fname;
						
					var searchItem=this.$refs['morefilter_'+this.item.l_id].searchItem;
					var searchlist=JSON.parse(JSON.stringify(searchItem));

					searchlist.forEach(e=>{
						// if(e.coltype=='datetime_mm'&&e.value!='')
						// {
						// 	e.value=this.$tool.datetotime(e.value);
						// }
						delete e.colsource;
					});
					search.searchItem=searchlist;
				}
			}
			return JSON.stringify(search);
		},
		ClearFilter(){
			this.sort='';
			if(this.showsearchinput){
				if(this.$refs['searchinput_'+this.item.l_id]!=undefined)
					this.$refs['searchinput_'+this.item.l_id].searchkey='';
			}
			
			if(this.showmorefilter){
				if(this.$refs['morefilter_'+this.item.l_id]!=undefined){
					this.$refs['morefilter_'+this.item.l_id].commfname='';
					if(this.$refs['morefilter_'+this.item.l_id].searchItem!=undefined){
						this.$refs['morefilter_'+this.item.l_id].searchItem.forEach(e=>{
							e.value='';
						});
					}
				}
			}
		},
		/*
		*isrefresh-是否刷新列表，从第一页开始
		* issearch --表示是否为手动筛选查找
		* */
		refreshgrid(isrefresh,issearch){
			if(issearch==undefined)
				issearch=false;
			this.istop = false;
			var isload = true;
			var pagecount=this.getpagecount();
			debugger
			if (isrefresh) {
				
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.istop = true;
				this.gridfilter='';
				this.listparam='';
			} else {
				//加载下一页
				if (parseInt(pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if(isload){
				if(isrefresh){
					var that = this;
					var paraminfo={
						l_mode:this.item.l_mode,
						search:this.GetSearchObj(),
						tab:this.item.type
					}
					//debugger
					//先获取筛选条件
					this.$apipost.get.AnalysisSearch({paraminfo:paraminfo}).then(re => {
						//再调用查询方法
						//debugger
						if(re.state=='1'){
							that.gridfilter=re.filter;
							if(re.listparam!=undefined)
								that.listparam=re.listparam;
							if(re.sort!=undefined&&that.sort=='')
								that.sort=re.sort;
							if(issearch&&!that.ispagecount)
								that.allcontrol(true);
							that.getTableData(isrefresh);
						}
					});
				}else
					this.getTableData(isrefresh);
			}
			else{
				this.loading=false;
				//this.$tool.loadingclose();
			}
		},
		getTableData(isrefresh){
			if(isrefresh)
				this.gridlist = [];
			//debugger
			var that=this;
			this.$apipost.get.CreateGrid({
			l_mode:that.item.l_mode,
			tab:that.item.type,
			pageindex:that.pageindex,
			showcol:JSON.stringify(that.columns),
			pagesize:this.pagesize,
			sort:that.sort,
			search:that.gridfilter,
			listparam:that.listparam,
			iscount:that.ispagecount,
			userid:localStorage.getItem('userid')}).then(res => {
				that.loading = false;
				//this.$tool.loadingclose();
				//debugger
				// if (!that.isloadscroll) 
				// 	that.gridscroll();
				if(isrefresh&&that.ispagecount)
				{
					that.count=res.count;
					that.pagecount=res.pagecount;
				}
				if(that.isgridexpand)
					res.data=that.SetGridChild(res.data);
				if (res.data.length > 0) {
					if (that.pageindex > 0) {
						that.gridlist = that.gridlist.concat(res.data);
					} else {
						that.gridlist = res.data;
					}
				}
				//console.log('列表数据'+JSON.stringify(that.gridlist));
				this.$nextTick(function() {
					if(that.isgridexpand){
						if(that.$refs['gridexpands_'+that.item.l_id]!=undefined)
							that.$refs['gridexpands_'+that.item.l_id].SetTableList(that.gridlist);
					}
				});
			});
		},
		getColumns(){
			
			var that = this;
			this.$apipost.get.GetColumns({ tab:this.item.type, checkfield:this.item.checkfield, parentid:this.item.l_id, mode: this.item.l_mode }).then(res => {
				//debugger
				//console.log('列配置',JSON.stringify(res));
				res.forEach(e=>{
					if(that.grid_lang[e.title]!=undefined)
						e.title=that.grid_lang[e.title];
					if(e.type=="template"){
						if(e.template!=undefined){
							e.template.forEach(b=>{
								if(that.grid_lang[b.title]!=undefined)
									b.title=that.grid_lang[b.title];
							});
						}
					}
				});
				that.columns = res;
				//console.log('tablegrid columns--'+JSON.stringify(this.item)+this.$tool.formatdate(),JSON.stringify(res));
				if (that.isgridexpand) {
					//设置子表的列配置，去掉勾选、去掉模板列
					var colums = res.filter(function(e) {
						return e.type != '' && e.type != 'template'&&e.colshow==1;
					});
					//debugger
					that.soncolumns = colums;
				}
				that.refreshgrid(true);
			});
		},
		gridhandle(e){
			//debugger
			//this.checkedrow=[];
			//this.checkedrow.push(e.row); //勾选了的列表
			debugger
			this.$public.ActionControl(e,this);
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				//console.log(scrollDistance);
				if (scrollDistance <= 170) {
					//debugger
					that.refreshgrid(false);
				}
			}
		},
		morefiltercb(e){
			this.refreshgrid(true,true);
		},
		resetfiltercb(e){
			//debugger
			this.ClearFilter();
			this.refreshgrid(true,true);
		},
		searchinputcb(e){
			this.refreshgrid(true,true);
		},
		buttoncb(e){
			var isgo=true;
			//debugger
			if(e.event=="single")
			{
				if(this.selectedall){
					if(this.gridlist.length!=1)
						isgo=false;
					else
						e.row=this.gridlist[0];
				}else{
					if(this.checkedrow.length!=1)
						isgo=false;
					else
						e.row=this.checkedrow[0];
				}
				if(!isgo)
					this.$tool.message(this.grid_lang.signlesel, 2);
				
			}else
			{
				if(!this.selectedall)
					e.row=this.checkedrow;
			}
			//debugger
			if(isgo){
				this.$public.ActionControl(e,this);
			}
		},
		layoutgridrollback(){
			
			//this.$emit('layoutgridrollback',{event:'settabcount'});
		},
		tabpagerollback(){
			//debugger
			//this.$emit('tabpagerollback',{event:'settabcount'});
		},
		allcontrol(istabcount){
			if(istabcount) //回调选项卡汇总方法
				this.$emit('allcontrol',{event:'settabcount',search:this.GetSearchObj()});
		},
		sethandelshow(e){
			//debugger
			if(e.type=='button')
				this.isbuttons=e.show;
			if(e.type=='reset')
				this.showreset=e.show;
			if(e.type=='searchinput')
				this.showsearchinput=e.show;
			if(e.type=='morefilter')
				this.showmorefilter=e.show;
		},
		//行双击
		rowdblclick(e){
			//双击事件
			//debugger
			if(this.item.l_dblclick!=''){
				var b=this.item.l_dblclick;
				b.row=e.row;
				this.$public.ActionControl(b,this);
			}
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) 
				this.checkedrow = e.rows; //勾选了的列表
			this.selectedall = e.selectedall;
		},
		//单元格单击
		cellclick(e){
			//debugger
			if(e.column.type=='openurl'){
				//debugger
				var templates=e.column.template;
				var par='';
				templates.forEach(b=>{
					if(e.row[b.col]==b.urltype){
						par=b.urlparam;
						return false;
					}
				});
				if(par!=''){
					var b=par;
					b.row=e.row;
					b.row[par.colname]=e.row[par.colkey];
					this.$public.ActionControl(b,this);
				}
			}
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			debugger
			this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty,col) {
			var pkval = '';
			var isgo = true;
			var search={};
			search[col]='';
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					pkval += e[col] + ',';
				});
				if (pkval != '') {
					pkval = pkval.substring(0, pkval.length - 1);
					search[col] = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo={pkcol:col};
					searchinfo.checkedrow=search;
					searchinfo = JSON.stringify(searchinfo);
				} else {
					if (!isempty) this.$tool.message(this.grid_lang.selempty, 2);
				}
			} else 
				searchinfo = this.GetSearchObj();
			return searchinfo;
		},
		//列表展开时加载子表信息
		getExpandsRow(e) {
			//debugger
			e.row.expand = e.expand;
			if (e.expand) {
				//加载子表信息
				this.loadsongrid(e.row, e.index);
			}
		},
		loadsongrid(row, index) {
			var that = this;
			var search = {
				groupid: row[this.item.l_tablename]
			};
			var paraminfo={
				l_mode:this.item.l_mode,
				search:search,
				tab:this.item.type
			}
			//debugger
			//先获取筛选条件
			this.$apipost.get.AnalysisSearch({paraminfo:paraminfo}).then(re => {
				//再调用查询方法
				//debugger
				if(re.state=='1'){
					//this.loading = true;
					that.$apipost.get.CreateGrid({
					l_mode:that.item.l_mode+ '子表',
					tab:that.item.type,
					pageindex:that.pageindex,
					showcol:JSON.stringify(this.soncolumns),
					pagesize:300,
					sort:'',
					listparam:re.listparam,
					search:re.filter,
					iscount:true,
					userid:localStorage.getItem('userid')}).then(reslist => {
						//debugger
						this.$nextTick(function() {
							if(that.$refs['gridexpands_'+that.item.l_id]!=undefined){
								that.$refs['gridexpands_'+that.item.l_id].sonDataList=reslist.data;
								that.$refs['gridexpands_'+that.item.l_id].SetExpandSonList(index,reslist.data);
							}
						});						
					});
				}
			});
		},
		SetGridChild(list){
			list.forEach(e=>{
				//if(e.haschild=='1')
				e.sonDataList=[];
			});
			return list;
		},
		getpagecount(){
			if(this.ispagecount)
				return this.pagecount;
			else{
				//debugger
				return this.$parent.$parent.$parent.$parent.getpagecount(this.item.type);
			}
		}
	}
}
</script>

<style>
</style>
